import { MappedImage } from "src/utils/fw"
import Podcast from "./Podcast"
import membership from "./membership"
import { useEffect } from "preact/hooks"
import { assignAchievement } from "src/components/Leaderboard"
import { userID } from "src/utils/datalayer"
import { leaderboardOptIn } from "src/161759/utils"

export const ezUtm = "?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2024_Congress_Orlando&utm_id=2024_Congress_Orlando"

export const convertLinksUTM = (link) => {
    return {
        ...link,
        href: !link.href.startsWith("mailto:") ? link.href + ezUtm : link.href
    }
}

export const effect = (achievementId) => () => {
    if (leaderboardOptIn)
        assignAchievement({
            achievementId,
            userId: userID,
            eventId: "161759"
        })
}

const LeadershipIn = () => {
    const bg = "https://assets.swoogo.com/uploads/full/4566336-6718158bd420d.png"

    useEffect(effect("f1ac8f01-20df-4182-893b-1d370c76ec0e"), [])

    return <MappedImage links={[
        {
            label: "Unlocking the business value of security",
            href: "https://www.isflive.org/s/article/Leadership-Insights-Unlocking-the-business-value-of-security",
            target: "_blank",
            width: "42%",
            height: "4.6%",
            left: "8%",
            top: "63%",
            onClick: effect("f80abaee-f0b9-4b2e-afa2-21ae308c8e9a")
        },
        {
            label: "Explaining the role of the BISO",
            href: "https://www.isflive.org/s/article/leadership-insights-exploring-the-role-of-the-business-information-security-officer-biso",
            target: "_blank",
            width: "42%",
            height: "4.6%",
            left: "8%",
            top: "68%",
            onClick: effect("9b75d4bf-5362-4ca2-b10a-05275bcf407c")
        },
        {
            label: "Building a model of the security leader",
            href: "https://www.isflive.org/s/article/leadership-insights-building-a-model-of-the-security-leader",
            target: "_blank",
            width: "42%",
            height: "4.6%",
            left: "50.6%",
            top: "63%",
            onClick: effect("1004dfb8-8201-422e-8855-1a1390e7506d")
        },
        {
            label: "Looking to the future",
            href: "https://www.isflive.org/s/article/leadership-insights-looking-to-the-future",
            target: "_blank",
            width: "42%",
            height: "4.6%",
            left: "50.6%",
            top: "68%",
            onClick: effect("b75402e5-adfb-457a-bab8-b08972ac2a20")
        },
        {
            label: "Contact the author - Paul Watts",
            href: "mailto:paul.watts@securityforum.org?subject=Leadership Insights series",
            target: "_blank",
            isExternal: true,
            width: "85%",
            height: "4.6%",
            left: "8%",
            top: "73%",
            onClick: effect("c8e47cc5-bce3-48c9-bf1a-f06878639597")
        },
        {
            label: "Join the Leadership and Strategy community",
            href:"https://www.isflive.org/s/topic/0TO0J000000U7KEWA0/leadership-and-strategy",
            target: "_blank",
            width: "42%",
            height: "5.5%",
            left: "29%",
            top: "81%",
            onClick: effect("c705c50b-1b71-48d8-9fd8-779704506533")
        }
    ].map(convertLinksUTM)} imageURL={bg} imageStyle="width:unset;">
        <iframe src="https://player.vimeo.com/video/1020926286?autoplay=1" allowfullscreen style={{
            width: "84.7%",
            height: "46.9%",
            left: "7.84%",
            top: "14%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}

const LIMetadata = {
    name: "Leadership Insights",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "90.9%",
        top: "9%",
    }
}

export const ISFAssure = () => {
    const bg = "https://assets.swoogo.com/uploads/full/4566334-6718158bc83e5.png"
    useEffect(effect("8dffa426-f0bb-4fed-83c1-3982059653b1"), [])

    return <MappedImage links={[
        {
            label: "Access the ISF ASSURE platform",
            href: "https://hub.securityforum.org/" + ezUtm,
            target: "_blank",
            width: "42%",
            height: "5.5%",
            left: "29%",
            top: "81%",
            onClick: effect("1f2a939b-7fbb-4a89-88af-2e3016674171")
        }
    ]} imageURL={bg} imageStyle="width:unset;">
        <iframe src="https://player.vimeo.com/video/1025222260?autoplay=1" allowfullscreen style={{
            width: "84.7%",
            height: "58.9%",
            left: "7.84%",
            top: "17.7%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}

export const IAMetadata = {
    name: "ISF Assure",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "90.9%",
        top: "11%",
    }
}

const CyberResilience = () => {
    const bg = "https://assets.swoogo.com/uploads/full/4566335-6718158bd1a78.png"

    useEffect(effect("25b47f0c-3432-4392-b9df-3dbc841030c0"), [])

    return <MappedImage links={[
        {
            label: "Cyber Simulation Exercises",
            href: "https://www.isflive.org/s/services-overview/cyber-simulation-exercise",
            target: "_blank",
            width: "41.6%",
            height: "5%",
            left: "8%",
            top: "75%",
            onClick: effect("db302d60-d8fe-4051-b4b2-8812efbda0c1")
        },
        {
            label: "Incident Response Toolkit",
            href: "https://www.isflive.org/s/services-overview/incident-response-toolkit",
            target: "_blank",
            width: "41.6%",
            height: "5%",
            left: "51%",
            top: "75%",
            onClick: effect("c8f7e007-d5a9-400f-a826-d92000f1e997")
        },
        {
            label: "Get in touch with our experts",
            href: "mailto:services@securityforum.org?subject=ISF Services enquiry",
            isExternal: true,
            target: "_blank",
            width: "42%",
            height: "5%",
            left: "29%",
            top: "84%",
            onClick: effect("b36e27bc-693e-47b8-a62b-1e5ea526f867")
        }
    ].map(convertLinksUTM)} imageURL={bg} imageStyle="width:unset;">
        <iframe src="https://player.vimeo.com/video/799826872?autoplay=1" allowfullscreen style={{
            width: "84.7%",
            height: "55.4%",
            left: "7.84%",
            top: "16.7%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}

const CRMetadata = {
    name: "Cyber Resilience",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "90.9%",
        top: "11%",
    }
}


export default {
    day: new Date("2024-11-10 00:00:00.000-05:00"),
    tvs: [
        [LeadershipIn, LIMetadata],
        [ISFAssure, IAMetadata],
        [CyberResilience, CRMetadata],
        Podcast(0),
        membership
    ]
}